import { logError } from 'utils/extra';

// DEPRECATED: This function is no longer used. It was used to log events to Mixpanel, which we no longer use. We now use Sentry for logging events and errors.
export default function logEvent(text, props) {
  if (process.env.REACT_APP_MODE === 'DEVELOPMENT') {
    console.log('Log Event: ', text);
  }

  try {
  } catch (e) {
    logError(e);
  }
}
